import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Field } from "@/pages/admin/Field";
import { fileUrl } from "@/lib/api";
import { Plus, Pencil, Trash2, X } from "lucide-react";
import { toast } from "sonner";

export default function ContentManager({ resource, title, fields, subtitle }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  const load = () => api.get(`/admin/content/${resource}`).then((r) => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, [resource]);

  const openNew = () => { setEditing(null); setForm({}); setOpen(true); };
  const openEdit = (it) => { setEditing(it); setForm(it); setOpen(true); };

  const save = async () => {
    setSaving(true);
    try {
      if (editing) await api.put(`/admin/content/${resource}/${editing.id}`, form);
      else await api.post(`/admin/content/${resource}`, form);
      toast.success("Tersimpan");
      setOpen(false); load();
    } catch { toast.error("Gagal menyimpan"); }
    finally { setSaving(false); }
  };

  const del = async (id) => {
    if (!window.confirm("Hapus item ini?")) return;
    await api.delete(`/admin/content/${resource}/${id}`);
    toast.success("Terhapus"); load();
  };

  const titleField = fields.find((f) => ["title", "name"].includes(f.name))?.name || fields[0].name;
  const imgField = fields.find((f) => f.type === "image")?.name;

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-syne font-bold text-3xl text-white">{title}</h1>
          {subtitle && <p className="text-white/50 mt-1">{subtitle}</p>}
        </div>
        <button onClick={openNew} className="btn-gold px-5 py-2.5 rounded-full flex items-center gap-2" data-testid={`add-${resource}`}><Plus className="w-4 h-4" /> Tambah</button>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((it) => (
          <div key={it.id} className="bg-ll-card rounded-2xl overflow-hidden gold-border" data-testid={`${resource}-item`}>
            {imgField && it[imgField] && <img src={fileUrl(it[imgField])} alt="" className="w-full h-40 object-cover" />}
            <div className="p-5">
              <h3 className="font-syne font-semibold text-white">{it[titleField]}</h3>
              <p className="text-white/50 text-sm mt-1 line-clamp-2">{it.description || it.excerpt || it.quote || it.type || it.category || ""}</p>
              <div className="flex gap-2 mt-4">
                <button onClick={() => openEdit(it)} className="flex-1 flex items-center justify-center gap-1.5 bg-white/5 hover:bg-white/10 text-white rounded-lg py-2 text-sm" data-testid={`edit-${resource}`}><Pencil className="w-3.5 h-3.5" /> Edit</button>
                <button onClick={() => del(it.id)} className="flex items-center justify-center gap-1.5 bg-red-500/10 hover:bg-red-500/20 text-red-400 rounded-lg py-2 px-3 text-sm" data-testid={`delete-${resource}`}><Trash2 className="w-3.5 h-3.5" /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-white/40 col-span-full">Belum ada data. Klik "Tambah" untuk membuat.</p>}
      </div>

      {open && (
        <div className="fixed inset-0 z-[80] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-[#0F1117] rounded-2xl gold-border w-full max-w-lg max-h-[88vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-5 border-b border-amber-500/15 sticky top-0 bg-[#0F1117]">
              <h3 className="font-syne font-bold text-white text-lg">{editing ? "Edit" : "Tambah"} {title}</h3>
              <button onClick={() => setOpen(false)} className="text-white/60 hover:text-white"><X className="w-5 h-5" /></button>
            </div>
            <div className="p-5 space-y-4">
              {fields.map((f) => (
                <div key={f.name}>
                  {f.type !== "checkbox" && <label className="text-xs text-white/50 uppercase tracking-widest mb-1.5 block">{f.label}</label>}
                  <Field field={f} value={form[f.name]} onChange={(v) => setForm({ ...form, [f.name]: v })} />
                </div>
              ))}
              <button onClick={save} disabled={saving} className="btn-gold w-full py-3 rounded-xl disabled:opacity-60" data-testid={`save-${resource}`}>{saving ? "Menyimpan…" : "Simpan"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
